import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { RoleCreateInput } from "@colab/shared";

export type CreateRoleResponse = { id: string };

// POST /api/settings/roles
//
// Replaces revalidatePath("/admin/settings/roles") from
// /app/admin/settings/roles/_actions.ts::createRole.
export function useCreateRole() {
  const queryClient = useQueryClient();
  return useMutation<CreateRoleResponse, ApiClientError, RoleCreateInput>({
    mutationFn: (input) =>
      apiFetch<CreateRoleResponse>("/settings/roles", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.roles() });
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.audit() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to create role");
    },
  });
}
